var React = require('react');

function ChevronLeft (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"rotate(-90 256 256)"},[React.createElement("path",{"d":"M256 512A254 254 0 010 256 254 254 0 01256 0a254 254 0 01256 256 254 254 0 01-256 256z","fill":"rgba(var(--bg-primary), var(--bg-alpha))","key":0}),React.createElement("path",{"d":"M394 290L256 152 118 290l28 28 110-110 110 110z","fill":"rgb(var(--text-tertiary))","key":1})]));
}

ChevronLeft.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = ChevronLeft;

ChevronLeft.default = ChevronLeft;
